import { schema } from "normalizr";

const subscriptionPlan = new schema.Entity(`subscription_plans`, {}, { idAttribute: `name` });
const arrayOfSubscriptionPlans = [subscriptionPlan];

const pricingModel = new schema.Entity(`pricing_model`, {}, { idAttribute: `name` });

const plan = new schema.Entity(`plans`, {}, { idAttribute: `name` });
const arrayOfPlans = [plan];

const addOn = new schema.Entity(`addons`, {}, { idAttribute: `name` });
const arrayOfAddOns = [addOn];

pricingModel.define({
  plans: arrayOfPlans,
  addons: arrayOfAddOns,
});

export { subscriptionPlan, arrayOfSubscriptionPlans, pricingModel };
